import { render, staticRenderFns } from "./report-details.vue?vue&type=template&id=488da3e0&scoped=true"
import script from "./report-details.vue?vue&type=script&lang=js"
export * from "./report-details.vue?vue&type=script&lang=js"
import style0 from "./report-details.vue?vue&type=style&index=0&id=488da3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488da3e0",
  null
  
)

export default component.exports